import React from 'react';
import SkeletonList from './SkeletonList';
import SkeletonDetails from './SkeletonDetails';
import { SkeletonAgentGrid } from './SkeletonAgent';
import './loading.css';

/**
 * Full-page placeholder that matches the destination layout.
 * type: 'properties' | 'details' | 'agents'
 */
const PageLoader = ({ type = 'properties' }) => {
  if (type === 'details') {
    return (
      <div className="page-loader">
        <SkeletonDetails />
      </div>
    );
  }

  if (type === 'agents') {
    return (
      <div className="page-loader container">
        <SkeletonAgentGrid count={6} />
      </div>
    );
  }

  return (
    <div className="page-loader container">
      <SkeletonList count={6} />
    </div>
  );
};

export default PageLoader;
